module.exports = __webpack_public_path__ + "static/img/W.0ceb72f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/W.png
// module id = 4iXm
// module chunks = 0